import { styled } from '@linaria/react';

export const StyledHeader = styled.header`
	position: sticky;
	z-index: 1;
	top: calc(0px + var(--safe-top));
	left: 0;
	display: flex;
	width: 100%;
	height: var(--header-height);
	/*
		Мы в остальной верстке очень полагаемся высоту хэдера
	*/
	max-height: var(--header-height);
	align-items: center;
	padding: 0 1.2rem;
	pointer-events: none;
`;
